import { render, staticRenderFns } from "./SettingBatchPrice.vue?vue&type=template&id=2919d297"
import script from "./SettingBatchPrice.vue?vue&type=script&lang=js"
export * from "./SettingBatchPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports